import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/spec_attr/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'Group', value: 'group', sortable: false, filterable: true, divider: true},
        {text: 'Name', value: 'name', sortable: false, filterable: true, divider: true},
        {text: 'Shortname', value: 'shortname', sortable: false, filterable: true, divider: true},
        {text: 'Units name', value: 'units_name', sortable: false, filterable: true, divider: true},
        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['group', 'name'],
        sortDesc: [false],
        multiSort: true,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        SpecAttrTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}